import React, { Component } from 'react'
import { Row, Col, Alert, Select, Switch, Button, Icon, Spin } from 'antd'
import EntTypesModel from '../models/EntTypesModel'
import LoadingComponent from '../components/Loading'

const Option = Select.Option

class AdminEntitiesForm extends Component {

    constructor(props) {
        super(props)
        this.updateForm = this.updateForm.bind(this)
        this.loadOptions = this.loadOptions.bind(this)
        this.loading = this.loading.bind(this)
        this.state = {
            ...this.props.data,
            loading: true,
            types: []
        }
    }

    loadOptions() {
        this.loading()
        EntTypesModel.findAll((result) => {
            var state = Object.assign({}, this.state)
            state.types = result
            state.loading = false
            this.setState(state)
        })
    }

    componentDidMount() {
        this.loadOptions()
    }

    componentWillReceiveProps(nextProps) {
        var state = {
            ...this.state,
            ...nextProps.data
        }
        this.setState(state)
    }

    updateForm(field, value) {
        const formData = this.state
        formData[field] = value
        this.setState(formData)
    }

    loading() {
        var state = Object.assign({}, this.state)
        state.loading = true
        this.setState(state)
    }

    render() {
        if (this.state.loading) return (<LoadingComponent />)
        return (
            <Row>
                <Col span={24}>
                    <form method="post" onSubmit={(e) => {
                        e.preventDefault()
                        this.loading()
                        this.props.storeItem(this.state)
                    }}>
                        <input type="hidden" ref="id" value={this.state.id} />

                        <Row>
                            <Col xs={24} sm={6}></Col>
                            <Col xs={24} sm={14}>
                                <legend>{this.state.id ? 'Alterar Entidade' : 'Criar Nova Entidade'}</legend>
                            </Col>
                        </Row>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="name" className="ant-form-item-required" title="Nome da Entidade">
                                    Nome da Entidade
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                                <input id="name"
                                    type="text"
                                    required="required"
                                    className="ant-input"
                                    value={this.state.name}
                                    ref="name"
                                    onChange={(e) => this.updateForm('name', e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="tipo_entidade_id" className="ant-form-item-required" title="Tipo de Entidade">
                                    Tipo de Entidade
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                                <Select value={''+this.state.tipo_entidade_id}
                                    showSearch
                                    placeholder="Escolha o tipo de entidade"
                                    optionFilterProp="children"
                                    onChange={(v) => this.updateForm('tipo_entidade_id', v)}>
                                    { this.state.types.map((item) => (
                                        <Option key={''+item.id} value={''+item.id}>{item.nome}</Option>
                                    ) )}
                                </Select>
                            </div>
                        </div>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="focal_point_email" className="ant-form-item" title="E-mail">
                                    E-mail do Ponto Focal
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                                <input id="focal_point_email"
                                    type="text"
                                    className="ant-input"
                                    value={this.state.focal_point_email || ''}
                                    ref="name"
                                    onChange={(e) => this.updateForm('focal_point_email', e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-6">
                                <label htmlFor="nome" className="ant-form-item-required" title="Activo">
                                    Notificações por E-mail de Novas Ocorrências
                                </label>
                            </div>
                            <div className="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-14">
                                <Switch checked={this.state.notify_email_new_issue}
                                    onChange={(checked) => this.updateForm('notify_email_new_issue', checked)}
                                />
                            </div>
                        </div>

                        <Row>
                            <Col xs={24} sm={6}></Col>
                            <Col xs={24} sm={14}>
                                <Alert className={this.props.complete && this.props.error ? '' : 'hidden'}
                                    message="Erro"
                                    description={this.props.error}
                                    type="error"
                                    showIcon
                                />
                                <Alert className={this.props.complete && !this.props.error ? '' : 'hidden'}
                                    message="Sucesso!"
                                    description="A entidade foi guardada com sucesso."
                                    type="success"
                                    showIcon
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={24} sm={6}></Col>
                            <Col xs={24} sm={14}>
                                <div style={{borderTop: '2px solid gray', marginTop: '16px', paddingTop: '8px'}}>
                                    <button type="submit" className="ant-btn ant-btn-primary"
                                        disabled={this.state.loading}
                                        style={{float: 'right'}}>
                                        { this.state.loading ? (<Spin />) : (<Icon type="save" />) }
                                        {' '}<span>Guardar</span>
                                    </button>
                                    <Button type="danger" onClick={(e) => this.props.history.push('/admin/entities')}>
                                        Cancelar
                                    </Button>
                                </div>
                            </Col>
                        </Row>

                    </form>
                </Col>
            </Row>
        )
    }
}

export default AdminEntitiesForm;



// WEBPACK FOOTER //
// ./src/components/AdminEntitiesForm.js